import React from "react";
import { Button, Modal } from "antd";

import DetailsMore from "./DetailsMore";

const list1 = [
  {
    label: "VIEW",
    content: "<a href='javascript:;'>More details</a>"
  },
  {
    label: "Inferred activity ",
    content: "<a href='javascript:;'>More details</a>"
  },
  {
    label: "GENE SYMBOL",
    content:
      "IGNF1 <br> Immunoglobulin-like and fibroconectin type III domain containing 1"
  },
  {
    label: "CLASSIFICATION",
    content: "Uncertain Significance"
  },
  {
    label: "POSITION",
    content: "chr1:201178844 [IGV] [UCS]"
  },
  {
    label: "cytoband",
    content: "q32.1"
  }
];

const list2 = [
  {
    label: "GENE SYMBOL",
    content: "IGNF1"
  },
  {
    label: "position",
    content: "201178844"
  },
  {
    label: "cytoband",
    content: "q32.1"
  },
  {
    label: "translation impact",
    content: "q32.1"
  },
  {
    label: "GENE region",
    content: "Exonic, Intronic"
  },
  {
    label: "GENE region",
    content: "c.1397G>T <br> p.G466V"
  },
  {
    label: "protein variant",
    content: "p.G1402R"
  }
];

class Details extends React.Component {
  constructor() {
    super();
    this.state = { visibleModal: false };
  }

  showModal = () => {
    this.setState({ visibleModal: true });
  };

  handleOk = () => {
    this.setState({ visibleModal: true });
  };

  handleCancel = () => {
    this.setState({ visibleModal: false });
  };

  render() {
    const { visibleModal } = this.state;
    return (
      <div className="details">
        <div className="details__head">
          <div className="details__title">p.G1402R</div>
          <div className="details__label label">Variant Details</div>
          <Button
            className="details__open ant-btn-icon-only"
            onClick={this.showModal}
          >
            <img src="/img/zoom-in.svg" alt="" />
          </Button>
          <Modal
            width={866}
            visible={visibleModal}
            centered={true}
            title={[
              <div className="details" key={0}>
                <div className="details__title">p.G1402R</div>
                <div className="details__label label">Variant Details</div>
              </div>
            ]}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            footer={false}
          >
            <DetailsMore />
          </Modal>
        </div>
        <div className="details__body">
          <div className="details__panel">
            <div className="details__list details__list_primary">
              {list1.map((x, i) => (
                <div className="details__item" key={i}>
                  <div className="details__label label">{x.label}</div>
                  <div
                    className="details__content"
                    dangerouslySetInnerHTML={{ __html: x.content }}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="details__list details__list_secondary">
            {list2.map((x, i) => (
              <div className="details__item" key={i}>
                <div className="details__label label">{x.label}</div>
                <div
                  className="details__content"
                  dangerouslySetInnerHTML={{ __html: x.content }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Details;
